// removed by extract-text-webpack-plugin
module.exports = {"infoRow":"cmziboEw9jh-wH2SQN8Mf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectConfirmation/ProjectConfirmation.scss
// module id = 1366
// module chunks = 1